import countries from './countries.json';
export function getCountries() {
    return countries;
}
export function getCountryNames() {
    return Object.values(countries);
}
export function getCountryAbbreviations() {
    return Object.keys(countries);
}
export function getAbbreviationByCountry(value) {
    return Object.keys(countries).find(function (key) { return countries[key] === value; });
}
//# sourceMappingURL=index.js.map